"use strict";

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_tag_1 = __importDefault(require("graphql-tag"));

exports.gql = graphql_tag_1.default;

var apollo_client_1 = require("apollo-client");

var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");

exports.InMemoryCache = apollo_cache_inmemory_1.InMemoryCache;

var apollo_link_1 = require("apollo-link");

var apollo_link_batch_http_1 = require("apollo-link-batch-http");

var apollo_links_1 = require("@8base/apollo-links");

var apollo_link_error_1 = require("apollo-link-error");

var apollo_utilities_1 = require("apollo-utilities");

var utils_1 = require("@8base/utils");
/**
 * Extended Apollo Client by 8base several links.
 *
 * @param {Object} config - The Apollo Client config.
 * @param {string} config.uri Endpoint of the GraphQl server.
 * @param {Function} config.getAuthState - The function which are using to get auth state.
 * @param {Function} config.getRefreshTokenParameters - The function which are using for get refresh token parameters.
 * @param {Function} config.onAuthSuccess - The callback which called when attempt to refresh authentication is success.
 * @param {Function} [config.onAuthError] - The callback which called when attempt to refresh authentication is failed.
 * @param {Function} [config.onIdTokenExpired] - The callback which called when id token is expired.
 * @param {Function} [config.onRequestSuccess] - The callback which called when request is success.
 * @param {Function} [config.onRequestError] - The callback which called when request is fail.
 * @param {Function} [config.extendLinks] - Function to extend standart array of the links.
 *
 * @return instance of the Apollo Client
 */


var ApolloClient =
/*#__PURE__*/
function (_apollo_client_1$Apol) {
  _inherits(ApolloClient, _apollo_client_1$Apol);

  function ApolloClient(config) {
    _classCallCheck(this, ApolloClient);

    var uri = config.uri,
        subscriptionUri = config.subscriptionUri,
        getAuthState = config.getAuthState,
        getRefreshTokenParameters = config.getRefreshTokenParameters,
        onAuthSuccess = config.onAuthSuccess,
        onAuthError = config.onAuthError,
        onIdTokenExpired = config.onIdTokenExpired,
        onRequestSuccess = config.onRequestSuccess,
        onRequestError = config.onRequestError,
        extendLinks = config.extendLinks,
        _config$withAuth = config.withAuth,
        withAuth = _config$withAuth === void 0 ? true : _config$withAuth,
        _config$autoSignUp = config.autoSignUp,
        autoSignUp = _config$autoSignUp === void 0 ? false : _config$autoSignUp,
        _config$withSubscript = config.withSubscriptions,
        withSubscriptions = _config$withSubscript === void 0 ? false : _config$withSubscript,
        authProfileId = config.authProfileId,
        rest = __rest(config, ["uri", "subscriptionUri", "getAuthState", "getRefreshTokenParameters", "onAuthSuccess", "onAuthError", "onIdTokenExpired", "onRequestSuccess", "onRequestError", "extendLinks", "withAuth", "autoSignUp", "withSubscriptions", "authProfileId"]);

    var cache = config.cache;

    if (!cache) {
      cache = new apollo_cache_inmemory_1.InMemoryCache();
    }

    var batchHttpLink = new apollo_link_batch_http_1.BatchHttpLink({
      uri: uri
    });
    var links = [batchHttpLink];

    if (withSubscriptions && getAuthState) {
      links = [apollo_link_1.ApolloLink.split(function (_ref) {
        var query = _ref.query;
        var definition = apollo_utilities_1.getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      }, new apollo_links_1.SubscriptionLink({
        uri: subscriptionUri || 'wss://ws.8base.com',
        getAuthState: getAuthState,
        onAuthError: onAuthError,
        onIdTokenExpired: onIdTokenExpired
      }), batchHttpLink)];
    }

    if (withAuth) {
      var authLink = new apollo_links_1.AuthLink({
        // @ts-ignore
        getAuthState: getAuthState,
        // @ts-ignore. Needs to check and remove this parameter.
        getRefreshTokenParameters: getRefreshTokenParameters,
        onAuthError: onAuthError,
        onAuthSuccess: onAuthSuccess,
        onIdTokenExpired: onIdTokenExpired
      });
      links = [authLink].concat(_toConsumableArray(links));

      if (autoSignUp) {
        if (!authProfileId) {
          throw new utils_1.SDKError(utils_1.ERROR_CODES.MISSING_PARAMETER, utils_1.PACKAGES.APOLLO_CLIENT, 'Please provide authProfileId if you want to enable auto sign up.');
        }

        var signUpLink = new apollo_links_1.SignUpLink({
          authProfileId: authProfileId,
          // @ts-ignore
          getAuthState: getAuthState
        });
        links = [signUpLink].concat(_toConsumableArray(links));
      }
    }

    if (typeof onRequestSuccess === 'function') {
      links = [new apollo_links_1.SuccessLink({
        successHandler: onRequestSuccess
      })].concat(_toConsumableArray(links));
    }

    if (typeof onRequestError === 'function') {
      links = [apollo_link_error_1.onError(onRequestError)].concat(_toConsumableArray(links));
    }

    if (typeof extendLinks === 'function') {
      links = extendLinks(links, {
        getAuthState: getAuthState
      });
    }

    var link = apollo_link_1.ApolloLink.from(links);
    return _possibleConstructorReturn(this, _getPrototypeOf(ApolloClient).call(this, Object.assign({
      cache: cache,
      link: link
    }, rest)));
  }

  return ApolloClient;
}(apollo_client_1.ApolloClient);

exports.ApolloClient = ApolloClient;